import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { Router } from '@angular/router'
import { SharedServices } from '../../../../services/shared.services'

@Component({
    selector: 'app-audit',
    templateUrl: './audit.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        './audit.component.css',
        '../../../../stagingcss/lui-select.component.css'],
})
export class AuditComponent implements OnInit {
    accessLog = 'hidden'
    accessAuditActive = ''
    accountAuditActive = ''
    accountLog = 'hidden'
    listAccessLog: any
    listStaffAccessLog: any
    listClientAccessLog: any
    resourceUrl = 'resource'
    list: any
    listAccountLog: any
    listStaffAccountLog: any
    en = {}
    showEN = true

    constructor(private authData: AuthService, private router: Router, private restApi: RestServices, private _sharedService: SharedServices) {
        this.accessLog = 'active'
        this.accessAuditActive = 'accessAuditActive'
    }

    ngOnInit() {
        this.mainClient()
        $('ons-page').find('.ng-scrollbar').addClass('-vertical')
    }

    mainClient() {
        const resourceDataAccessLog = {
            actions: [],
            status: {
                access_log: {
                    paths: {
                        '{}': true,
                    },
                },
                clientMail: {
                    paths: {
                        '{}': true,
                    },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                client: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }

        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataAccessLog, tokenReNew).subscribe(
                success => {
                    const listlistAccessLogData = this.listAccessLog = success['response']['access_log']['paths']['{}']
                    const listStaffAccessLogData = this.listStaffAccessLog = success['response']['staff']['paths']['{}']
                    const listClientAccessLogData = this.listClientAccessLog = success['response']['client']['paths']['{}']
                    listlistAccessLogData.forEach(function(AccessLogItem) {
                        listStaffAccessLogData.forEach(function(StaffAccessLogItem) {
                            if (AccessLogItem.staffId === StaffAccessLogItem._id) {
                                if (StaffAccessLogItem.familyName) {
                                    AccessLogItem.operator = StaffAccessLogItem.firstName + StaffAccessLogItem.familyName
                                } else {
                                    AccessLogItem.operator = StaffAccessLogItem.firstName
                                }
                                AccessLogItem.operatorDeleted = StaffAccessLogItem.deleted
                            }
                        })
                        listClientAccessLogData.forEach(function(clientAccessLogItem) {
                            if (AccessLogItem.clientId) {
                                if (AccessLogItem.clientId != '') {
                                    if (AccessLogItem.clientId === clientAccessLogItem._id) {
                                        if (clientAccessLogItem.familyName) {
                                            AccessLogItem.operatorNameClient = clientAccessLogItem.firstName + clientAccessLogItem.familyName
                                        } else {
                                            AccessLogItem.operatorNameClient = clientAccessLogItem.firstName
                                        }
                                    }
                                }
                            }

                        })
                        AccessLogItem.modal = 'AccessLog'
                    })
                },
            )
        })
    }

    selectAccessDetail(accessLogDetail) {
        this._sharedService.emitChange(accessLogDetail)
    }

    selectAccountDetail(accountLogDetail) {
        this._sharedService.emitChange(accountLogDetail)
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }


    selectTabAccessLog() {
        this.accessLog = 'active'
        this.accountLog = 'hidden'
        this.accessAuditActive = 'accessAuditActive'
        this.accountAuditActive = ''
    }

    selectTabAccountLog() {
        this.accountLog = 'active'
        this.accessLog = 'hidden'
        this.accessAuditActive = ''
        this.accountAuditActive = 'accountAuditActive'
        const resourceDataAccountLog = {
            actions: [],
            status: {
                access_log: {
                    paths: {
                        '{}': true,
                    },
                },
                account_log: {
                    paths: {
                        '{}': true,
                    },
                },
                clientMail: {
                    paths: {
                        '{}': true,
                    },
                },
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                client: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(this.resourceUrl, resourceDataAccountLog, tokenReNew).subscribe(
                success => {
                    const listlistAccountLogData = this.listAccountLog = success['response']['account_log']['paths']['{}']
                    const listStaffAccountLogData = this.listStaffAccountLog = success['response']['staff']['paths']['{}']
                    listlistAccountLogData.forEach(function(AccountLogItem) {
                        listStaffAccountLogData.forEach(function(StaffAccountLogItem) {
                            if (AccountLogItem.staffId === StaffAccountLogItem._id) {
                                if (StaffAccountLogItem.familyName) {
                                    AccountLogItem.operator = StaffAccountLogItem.firstName + StaffAccountLogItem.familyName
                                } else {
                                    AccountLogItem.operator = StaffAccountLogItem.firstName
                                }
                                AccountLogItem.operatorDeleted = StaffAccountLogItem.deleted
                            }
                        })
                        AccountLogItem.modal = 'AccountLog'
                    })
                },
            )
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/status/audit/audit.component.ts